<template>
  <div style="display: inline-block; margin: 0 8px;">
    <!-- 外置按钮 -->
    <el-button @click="dialogVisible = true" type="primary" plain style="width: 100%;">
      智能代码
    </el-button>
    <!-- 点击弹出框 -->
    <el-dialog :visible.sync="dialogVisible" width="500px" @close="dialogVisible = false" center append-to-body>
      <div style="padding: 15px;">
        <div style="text-align: center;width: 100%;font-weight: bolder;font-size: large;">智能代码</div>
        <!-- 代码输入框 -->
        <el-input v-model="inputText" class="input-class" placeholder="请输入代码"></el-input>
        <directory-select v-model="path" style="margin-top: 15px;" placeholder="目标文件生成路径"></directory-select>
        <!-- 提示词模板输入框 -->
        <div class="flex-ac" style="margin-top: 20px;">
          <el-input placeholder="请输入生成代码的prompt" v-model="inputText"></el-input>
          <div style="width: 2px;"></div>
          <el-button icon="el-icon-s-promotion" @click="clickSubmit">提交</el-button>
        </div>
        <!-- 生成代码输出区 -->
        <textarea style="width: 100%;margin-top: 15px;height: 300px;" v-model="sqlText" placeholder="  生成代码文件内容">

        </textarea>
        <!-- 生成文件名输入框 -->
        <el-input v-model="inputText" class="input-class" placeholder="请输入生成文件名"></el-input>
        <!-- 生成文件路径输入框 -->
        <el-input v-model="inputText" class="input-class" placeholder="请输入生成文件路径"></el-input>
        <!-- 用户指令输入框 -->
        <el-input v-model="inputText" class="input-class" placeholder="请输入用户指令">用户指令来驱动上面内容的自动化，先完成简单的</el-input>
      </div>
      <!-- 底部按钮区 -->
      <template #footer class="dialog-footer">
        <el-button @click="handleSubmit" type="primary">生成</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'AICustomDialogButton',
  data() {
    return {
      dialogVisible: false,
      inputText: '',
      selectedTemplate: '',
      templates: [
        { value: 'template1', label: '模板一' },
        { value: 'template2', label: '模板二' },
        { value: 'template3', label: '模板三' }
      ]
    };
  },
  methods: {
    handleSubmit() {
      // 处理提交逻辑，例如发送数据到服务器等
      console.log('提交的文本:', this.inputText);
      console.log('选择的模板:', this.selectedTemplate);
      this.dialogVisible = false; // 提交后关闭弹窗，根据实际需求可调整
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-footer {
  padding: 0;
  text-align: right;
}
.input-class {
  margin-top: 12px;
}
</style>
<script setup>
</script>